module.exports = __webpack_public_path__ + "c08bcb70f0eb46797da5b5c41a86fef2.pdf";